import { render, staticRenderFns } from "./publish-status.vue?vue&type=template&id=5b24f448"
import script from "./publish-status.vue?vue&type=script&lang=ts"
export * from "./publish-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports